/* Father's Day Court Ranger V2 Listicle — scoped behaviors */
(function () {
  'use strict';

  var root = document.querySelector('.fdv2c');
  if (!root) return;

  /* ---------- Reveal-on-scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('fw-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    root.querySelectorAll('.fw-reveal').forEach(function (el) { io.observe(el); });
  } else {
    root.querySelectorAll('.fw-reveal').forEach(function (el) { el.classList.add('fw-visible'); });
  }

  /* ---------- Smooth-scroll for anchor CTAs ---------- */
  root.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href').slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ---------- Countdown helpers ---------- */
  // Standard shipping deadline: June 16, 2026 11:59 PM MST = June 17, 06:59 UTC
  var DEADLINE_MS = new Date('2026-06-17T06:59:00Z').getTime();

  function pad(n) { return String(n).padStart(2, '0'); }

  function diffParts(ms) {
    var d = Math.floor(ms / 86400000);
    var h = Math.floor((ms % 86400000) / 3600000);
    var m = Math.floor((ms % 3600000) / 60000);
    var s = Math.floor((ms % 60000) / 1000);
    return { d: d, h: h, m: m, s: s };
  }

  /* ---------- Promo bar countdown ---------- */
  var promo = root.querySelector('.fdv2c-promo-countdown');
  function tickPromo() {
    if (!promo) return;
    var diff = DEADLINE_MS - Date.now();
    var nums = promo.querySelectorAll('.fdv2c-promo-cd-num');
    if (diff <= 0) {
      var promoText = root.querySelector('.fdv2c-promo-text');
      if (promoText) promoText.innerHTML = '<strong>Last chance:</strong> Order today with expedited shipping only.';
      promo.style.display = 'none';
      return;
    }
    var p = diffParts(diff);
    if (nums.length >= 3) {
      nums[0].textContent = pad(p.d);
      nums[1].textContent = pad(p.h);
      nums[2].textContent = pad(p.m);
    }
  }

  /* ---------- Shipping section countdown ---------- */
  var shipCd = document.getElementById('fdv2c-countdown');
  function tickShip() {
    if (!shipCd) return;
    var diff = DEADLINE_MS - Date.now();
    if (diff <= 0) {
      shipCd.innerHTML = '<div class="fdv2c-countdown-expired"><strong>Standard shipping cutoff has passed.</strong> Expedited 2-day shipping available through June 18.</div>';
      var shipCta = document.getElementById('fdv2c-shipping-cta');
      if (shipCta) shipCta.textContent = 'Order with Expedited Shipping →';
      return;
    }
    var p = diffParts(diff);
    var dEl = shipCd.querySelector('[data-d]');
    var hEl = shipCd.querySelector('[data-h]');
    var mEl = shipCd.querySelector('[data-m]');
    var sEl = shipCd.querySelector('[data-s]');
    if (dEl) dEl.textContent = pad(p.d);
    if (hEl) hEl.textContent = pad(p.h);
    if (mEl) mEl.textContent = pad(p.m);
    if (sEl) sEl.textContent = pad(p.s);
  }

  tickPromo();
  tickShip();
  setInterval(function () { tickPromo(); tickShip(); }, 1000);

  /* ---------- FAQ accordion ---------- */
  root.querySelectorAll('.fdv2c-faq__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      if (expanded) {
        panel.style.maxHeight = '0px';
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });

  /* ---------- Sticky mobile CTA reveal ---------- */
  var sticky = document.querySelector('.fdv2c-sticky-mobile');
  var hero = document.querySelector('.fdv2c-hero');
  if (sticky && hero) {
    var threshold = 400;
    function onScroll() {
      if (window.scrollY > threshold) {
        sticky.classList.add('fdv2c-sticky-visible');
      } else {
        sticky.classList.remove('fdv2c-sticky-visible');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Creator video facade (lazy YouTube) ---------- */
  root.querySelectorAll('.fdv2c-video-facade').forEach(function (facade) {
    function activate() {
      var id = facade.getAttribute('data-yt-id');
      if (!id) return;
      facade.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0" title="Creator review of the FORWRD Court Ranger V2" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
    }
    facade.addEventListener('click', activate);
    facade.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(); }
    });
  });

  /* ---------- Tracking: Meta Pixel + Klaviyo + GA4 ---------- */
  try {
    if (typeof fbq === 'function') {
      fbq('track', 'ViewContent', {
        content_name: 'Fathers Day Ranger V2 LP',
        content_category: 'Landing Page',
        content_ids: ['RANGER-V2'],
        content_type: 'product',
        value: 195.00,
        currency: 'USD'
      });
    }
  } catch (e) {}
  try {
    window._learnq = window._learnq || [];
    window._learnq.push(['track', 'Viewed Fathers Day Ranger LP']);
  } catch (e) {}
  try {
    if (typeof gtag === 'function') {
      gtag('event', 'view_fathers_day_lp', { page_location: window.location.href });
    }
  } catch (e) {}

  root.querySelectorAll('[data-fdv2c-cta]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var loc = btn.getAttribute('data-fdv2c-cta') || '';
      try {
        if (typeof fbq === 'function') {
          fbq('track', 'InitiateCheckout', {
            content_name: 'Fathers Day Ranger V2 LP CTA',
            content_ids: ['RANGER-V2'],
            value: 179.00,
            currency: 'USD'
          });
        }
      } catch (e) {}
      try {
        if (typeof gtag === 'function') {
          gtag('event', 'click_fd_cta', { content_location: loc });
        }
      } catch (e) {}
    });
  });
})();
